import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import { default1jaun537xukbl as default_0 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Defaults.mjs';
import { get_displayNamehv5zo902rjy4 as get_displayName } from './Annotations.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { RenderContextxikz99gtpuie as RenderContext } from './RenderContext.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import {
  get_serializableOptions2omofumtgto14 as get_serializableOptions,
  SealedSerializableOptionlt11v40irrdi as SealedSerializableOption,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializableProperty.mjs';
import { toList383f556t1dixk as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { get_atTopy2id3zo687kr as get_atTop } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints19w9rda6g3rqz as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { weight31wqab1913ly4 as weight } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance29ka8gqgdrya1 as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/ScreenTransitions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { MySealedClassSerializerInterface1lg9fzm3qtbhk as MySealedClassSerializerInterface } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/MySealedClassSerializer.mjs';
import {
  cellFormub3o1hqp20e5 as cellForm,
  labeledForm2ame2d0a5lql9 as labeledForm,
  labeledView3rpvir7z2o9ii as labeledView,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { SEALED_getInstance19i1cdv1u9v1e as SEALED_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerNormalSealed(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(), NormalSealedRenderer_instance);
}
function NormalSealedRenderer$form$lambda$lambda(it) {
  return default_0(it.serializer_1);
}
function NormalSealedRenderer$form$lambda$lambda_0(it) {
  return get_displayName(it.serializer_1);
}
function NormalSealedRenderer$form$lambda$lambda$lambda$lambda(it) {
  return it;
}
function NormalSealedRenderer$form$lambda$lambda$lambda($next, $context, $value, $module, $serializer) {
  return ($this$swap) => {
    var selectedType = $next;
    var tmp = selectedType.serializer_1;
    var subSerializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
    var subContext = new (RenderContext())(subSerializer, $context.fieldAnnotations_1);
    var tmp_0 = (it) => equals(serializableOptionsIdentify($serializer, it), selectedType) ? it : default_0(subSerializer);
    var subValue = $value.lens_drj4fu_k$(tmp_0, NormalSealedRenderer$form$lambda$lambda$lambda$lambda);
    $module.form_gqhwsi_k$(subContext, subValue)($this$swap);
    return Unit_instance;
  };
}
function NormalSealedRenderer$view$lambda$lambda$lambda($next, $context, $value, $module, $serializer) {
  return ($this$swap) => {
    var selectedType = $next;
    var tmp = selectedType.serializer_1;
    var subSerializer = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
    var subContext = new (RenderContext())(subSerializer, $context.fieldAnnotations_1);
    var subValue = lens($value, (it) => selectedType.equals(serializableOptionsIdentify($serializer, it)) ? it : default_0(subSerializer));
    $module.view_ntgxjz_k$(subContext, subValue)($this$swap);
    return Unit_instance;
  };
}
var NormalSealedRendererClass;
function NormalSealedRenderer() {
  if (NormalSealedRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Options';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_28tizu_k$(context, module_0) {
        var tmp;
        var tmp_0 = context.serializer_1;
        if (tmp_0 instanceof AbstractPolymorphicSerializer()) {
          tmp = 0.9;
        } else {
          tmp = -1.0;
        }
        return tmp;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_28tizu_k$(context, module_0);
      }
      columnWidth_g6s04q_k$(context, module_0) {
        return 20.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_g6s04q_k$(context, module_0);
      }
      form_klw3k6_k$(context, value, module_0) {
        var serializer = context.serializer_1;
        var tmp0_elvis_lhs = get_serializableOptions(serializer);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp = [];
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var options = toList(tmp);
        return (_this__u8e3s4) => {
          var tmp = (it) => {
            var tmp0_elvis_lhs = serializableOptionsIdentify(serializer, it);
            return tmp0_elvis_lhs == null ? first(options) : tmp0_elvis_lhs;
          };
          var type = value.lens_drj4fu_k$(tmp, NormalSealedRenderer$form$lambda$lambda);
          var tt = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(type));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var this_0 = sizeConstraints(get_atTop(element), VOID, VOID, VOID, VOID, VOID, get_rem(10));
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          var this_1 = themed(this_0, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (Select())(this_1.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_1.willAddChild_hz2iwc_k$(element_0);
          var tmp_0 = _Constant___init__impl__v45mub(options);
          element_0.bind_64a41i_k$(type, new (Constant())(tmp_0), NormalSealedRenderer$form$lambda$lambda_0);
          element_0.onStartup_vrxh3i_k$();
          this_1.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
          var this_2 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (SwapView())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_2.willAddChild_hz2iwc_k$(element_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
          var this_3 = element_1;
          var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var alreadySwapping = {_v: false};
          reactive(this_3, 8, ($this$reactive) => {
            var c = $this$reactive.invoke_r7m7el_k$(tt);
            queue.add_utx5q5_k$(c);
            var tmp;
            if (alreadySwapping._v) {
              return Unit_instance;
            }
            alreadySwapping._v = true;
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!queue.isEmpty_y1axqb_k$()) {
                break $l$loop;
              }
              var next = queue.removeAt_6niowx_k$(0);
              try {
                var tmp_0 = Companion_getInstance().Fade_1;
                this_3.swap_26x94b_k$(tmp_0, NormalSealedRenderer$form$lambda$lambda$lambda(next, context, value, module_0, serializer));
              } catch ($p) {
                if ($p instanceof Exception()) {
                  var e = $p;
                  report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
                } else {
                  throw $p;
                }
              }
            }
            alreadySwapping._v = false;
            return Unit_instance;
          });
          element_1.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_klw3k6_k$(context, value, module_0);
      }
      view_3m91zp_k$(context, value, module_0) {
        var serializer = context.serializer_1;
        var tmp0_elvis_lhs = get_serializableOptions(serializer);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp = [];
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var options = toList(tmp);
        return (_this__u8e3s4) => {
          var tt = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
            var tmp0_elvis_lhs = serializableOptionsIdentify(serializer, $this$remember.invoke_r7m7el_k$(value));
            return tmp0_elvis_lhs == null ? first(options) : tmp0_elvis_lhs;
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
          element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => get_displayName($this$invoke.invoke_r7m7el_k$(tt).serializer_1));
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
          var this_0 = weight(element, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (SwapView())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          this_0.willAddChild_hz2iwc_k$(element_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
          var this_1 = element_1;
          var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var alreadySwapping = {_v: false};
          reactive(this_1, 8, ($this$reactive) => {
            var c = $this$reactive.invoke_r7m7el_k$(tt);
            queue.add_utx5q5_k$(c);
            var tmp;
            if (alreadySwapping._v) {
              return Unit_instance;
            }
            alreadySwapping._v = true;
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!queue.isEmpty_y1axqb_k$()) {
                break $l$loop;
              }
              var next = queue.removeAt_6niowx_k$(0);
              try {
                var tmp_0 = Companion_getInstance().Fade_1;
                this_1.swap_26x94b_k$(tmp_0, NormalSealedRenderer$view$lambda$lambda$lambda(next, context, value, module_0, serializer));
              } catch ($p) {
                if ($p instanceof Exception()) {
                  var e = $p;
                  report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
                } else {
                  throw $p;
                }
              }
            }
            alreadySwapping._v = false;
            return Unit_instance;
          });
          element_1.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_3m91zp_k$(context, value, module_0);
      }
      cellView_hcodjr_k$(context, value, module_0) {
        var tmp = context.serializer_1;
        var serializer = isInterface(tmp, MySealedClassSerializerInterface()) ? tmp : THROW_CCE();
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var currentValue = $this$invoke.invoke_r7m7el_k$(value);
            // Inline function 'kotlin.collections.find' call
            var tmp0 = serializer.get_options_jecmyz_k$();
            var tmp$ret$4;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
              while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
                var element = _iterator__ex2g4s.next_20eer_k$();
                if (element.isInstance_1(currentValue)) {
                  tmp$ret$4 = element;
                  break $l$block;
                }
              }
              tmp$ret$4 = null;
            }
            var tmp0_elvis_lhs = tmp$ret$4;
            var selectedType = tmp0_elvis_lhs == null ? first(serializer.get_options_jecmyz_k$()) : tmp0_elvis_lhs;
            return get_displayName(selectedType.serializer_1);
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_hcodjr_k$(context, value, module_0);
      }
    }
    protoOf($).cellForm_4mayde_k$ = cellForm;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'NormalSealedRenderer', VOID, VOID, [Renderer()]);
    NormalSealedRendererClass = $;
  }
  return NormalSealedRendererClass;
}
var NormalSealedRenderer_instance;
function NormalSealedRenderer_getInstance() {
  return NormalSealedRenderer_instance;
}
function serializableOptionsIdentify(_this__u8e3s4, item) {
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof AbstractPolymorphicSerializer() ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var poly = tmp;
  if (!equals(_this__u8e3s4.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), SEALED_getInstance()))
    return null;
  var tmp_0 = StubPolymorphicEncoder_getInstance();
  var tmp1_elvis_lhs = poly.findPolymorphicSerializerOrNull_sqpvzc_k$(tmp_0, !(item == null) ? item : THROW_CCE());
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  var ser = tmp_1;
  var tmp2_safe_receiver = get_serializableOptions(_this__u8e3s4);
  var tmp_2;
  if (tmp2_safe_receiver == null) {
    tmp_2 = null;
  } else {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = tmp2_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp2_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element.serializer_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() === ser.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$()) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    tmp_2 = tmp$ret$0;
  }
  var tmp3_safe_receiver = tmp_2;
  var tmp_3;
  if (tmp3_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_3 = tmp3_safe_receiver instanceof SealedSerializableOption() ? tmp3_safe_receiver : THROW_CCE();
  }
  return tmp_3;
}
var StubPolymorphicEncoderClass;
function StubPolymorphicEncoder() {
  if (StubPolymorphicEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      constructor() {
        return new.target.new_com_lightningkite_kiteui_forms_StubPolymorphicEncoder_gf5bx_k$();
      }
      static new_com_lightningkite_kiteui_forms_StubPolymorphicEncoder_gf5bx_k$() {
        StubPolymorphicEncoder_instance = null;
        var $this = this.new_kotlinx_serialization_encoding_AbstractEncoder_2d7vxe_k$();
        StubPolymorphicEncoder_instance = $this;
        $this.serializersModule_1 = EmptySerializersModule();
        return $this;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
    }
    initMetadataForObject($, 'StubPolymorphicEncoder');
    StubPolymorphicEncoderClass = $;
  }
  return StubPolymorphicEncoderClass;
}
var StubPolymorphicEncoder_instance;
function StubPolymorphicEncoder_getInstance() {
  if (StubPolymorphicEncoder_instance === VOID)
    StubPolymorphicEncoder().new_com_lightningkite_kiteui_forms_StubPolymorphicEncoder_gf5bx_k$();
  return StubPolymorphicEncoder_instance;
}
//region block: init
NormalSealedRenderer_instance = new (NormalSealedRenderer())();
//endregion
//region block: exports
export {
  registerNormalSealed as registerNormalSealedl18cy3gxoyfw,
};
//endregion

//# sourceMappingURL=NormalSealedRenderer.mjs.map
